import React from "react";
import {
  EditorProvider,
  Editor,
  Toolbar,
  BtnBold,
  BtnItalic,
  BtnUnderline,
  BtnNumberedList,
  BtnBulletList,
  Separator,
  BtnUndo,
  BtnRedo,
} from "react-simple-wysiwyg";

const RichTextEditor = ({
  value,
  onChange,
  placeholder = "Type here...",
  height = "150px",
}) => {
  const normalizeValue = (val) => {
    if (!val || val === "<br>" || val === "<p><br></p>") {
      return "";
    }
    return val;
  };
  
  return (
    <div style={{ width: "100%" }}>
      <EditorProvider>
        <Editor
          value={value}
          onChange={(e) => onChange(normalizeValue(e.target.value))}
          placeholder={placeholder}
          style={{
            minHeight: height,
            padding: "12px",
          }}
        >
          <Toolbar>
            <BtnBold />
            <BtnItalic />
            <BtnUnderline />
            <Separator />
            <BtnNumberedList />
            <BtnBulletList />
            <Separator />
            <BtnUndo />
            <BtnRedo />
          </Toolbar>
        </Editor>
      </EditorProvider>
    </div>
  );
};

export default RichTextEditor;
